// 用户日志相关请求
import { request } from '@/utils'

// 获取用户日志列表（后端返回 data 为日志数组）
export function getUserLogsAPI() {
  return request({
    url: '/user-log/get-logs',
    method: 'GET',
  })
}
